/**
 * 계정 페이지 주문 목록 → 엑셀 한 장 (My Order · Wholesale Orders 의 Download Excel, 2026-10-06).
 * 열은 화면 목록과 같다(Order No. · Date · Status · Amount) + Currency. 금액은 숫자 셀(엑셀에서 합계를 낼 수 있게).
 * 머리글 스타일은 백오피스 표 내보내기(GridToolBar)와 같다. `xlsx-js-style` 은 무거워서 버튼을 누를 때만 불러온다.
 */
export interface OrderExcelRow {
	id: string
	/** YYYY-MM-DD (로컬 날짜) */
	date: string
	status: string
	amount: number
	currency: string
}

export const downloadOrdersExcel = async ({
	rows,
	sheetName,
	fileName,
}: {
	rows: OrderExcelRow[]
	sheetName: string
	fileName: string
}): Promise<void> => {
	const { default: XLSX } = await import('xlsx-js-style')

	const headers = ['Order No.', 'Date', 'Status', 'Amount', 'Currency']
	const data = rows.map(aRow => [
		aRow.id,
		aRow.date,
		aRow.status,
		aRow.amount,
		aRow.currency,
	])

	const ws = XLSX.utils.aoa_to_sheet([headers, ...data])

	headers.forEach((_, ci) => {
		const addr = XLSX.utils.encode_cell({ r: 0, c: ci })
		ws[addr].s = {
			fill: { fgColor: { rgb: '16181B' } },
			font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
			alignment: { horizontal: 'center', vertical: 'center' },
		}
	})
	rows.forEach((aRow, ri) => {
		const addr = XLSX.utils.encode_cell({ r: ri + 1, c: 3 })
		if (ws[addr]) ws[addr].z = aRow.currency === 'KRW' ? '#,##0' : '#,##0.00'
	})

	const widths = headers.map((aHeader, ci) =>
		Math.max(aHeader.length, ...data.map(aRow => String(aRow[ci] ?? '').length)),
	)
	ws['!cols'] = widths.map(w => ({ wch: Math.max(w + 3, 10) }))

	const wb = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(wb, ws, sheetName)
	XLSX.writeFile(wb, fileName)
}

/** 오늘 — 로컬 YYYY-MM-DD (파일 이름용) */
export const todayStamp = (): string => {
	const d = new Date()
	return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10)
}
